module.exports = __webpack_public_path__ + "static/media/contact-dyk.3468d412.svg";